import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'mocra',
    labelKey: 'chatbot.suggestions.mocra',
    messageKey: 'chatbot.suggestions.mocraMessage',
  },
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'locations',
    labelKey: 'chatbot.suggestions.locations',
    messageKey: 'chatbot.suggestions.locationsMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 */
export const contactCTAs: ContactCTA[] = [
  {
    kind: 'copy',
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 0332 470 000',
  },
  {
    kind: 'copy',
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@hsacosmetics.com',
  },
]
